import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconButton, Menu, MenuItem, Typography, Box, Tooltip } from "@mui/material";
import { Language as LanguageIcon } from "@mui/icons-material";

const LANGUAGES = [
  { code: "en", name: "English", label: "EN", flag: "🇺🇸" },
  { code: "th", name: "ภาษาไทย", label: "TH", flag: "🇹🇭" },
  { code: "lo", name: "ພາສາລາວ", label: "LA", flag: "🇱🇦" },
];

const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);

  const current = LANGUAGES.find(l => l.code === i18n.language) || LANGUAGES[0];

  const handleChange = (code) => {
    i18n.changeLanguage(code);
    setAnchorEl(null);
  };

  return (
    <>
      <Tooltip title="Language / ภาษา / ພາສາ">
        <IconButton
          onClick={(e) => setAnchorEl(e.currentTarget)}
          color="inherit"
          size="small"
          sx={{ gap: 0.5, borderRadius: 1.5, px: 0.75 }}
        >
          <LanguageIcon sx={{ fontSize: "18px" }} />
          <Typography variant="caption" fontWeight={700} sx={{ fontSize: "0.7rem", lineHeight: 1 }}>
            {current.label}
          </Typography>
        </IconButton>
      </Tooltip>
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{ sx: { minWidth: 160 } }}
      >
        {LANGUAGES.map((lang) => (
          <MenuItem
            key={lang.code}
            selected={lang.code === current.code}
            onClick={() => handleChange(lang.code)}
          >
            <Box display="flex" alignItems="center" gap={1}>
              <Typography fontSize="1.1rem">{lang.flag}</Typography>
              <Typography variant="body2">{lang.name}</Typography>
            </Box>
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};

export default LanguageSwitcher;